import React from 'react';

/**
 * 팝업 본문 미리보기용 — HTTP/HTTPS URL을 링크로 렌더한다.
 * 슬롯 편집기와 가입혜택 탭 미리보기가 같은 표시를 내야 하므로 공용 모듈로 둔다
 * (미리보기의 목적이 앱 표시 확인인데 링크 여부가 화면마다 다르면 확인이 부정확해진다).
 */
function LinkifiedText({ children }) {
    const text = String(children || '');
    const parts = text.split(/(https?:\/\/[^\s<>"']+)/gi);
    return parts.map((part, index) => /^https?:\/\//i.test(part)
        ? <a key={`${part}-${index}`} href={part} target="_blank" rel="noreferrer">{part}</a>
        : <React.Fragment key={index}>{part}</React.Fragment>);
}

export default LinkifiedText;
